import type { EventName } from "@mw/shared/analyticsEventNames";

import { _captureEvent } from "@/app/_analytics/analytics";
import { usePostHog } from "posthog-js/react";

export const useAnalytics = () => {
  const posthog = usePostHog();
  return {
    captureEvent: (event: EventName, properties?: { [key: string]: any }) => _captureEvent(posthog, event, properties),
  };
};
